import React, { createContext, useContext } from 'react';
import { useThemeContext } from './ThemeContext.jsx';
import { useStores } from '../hooks/useStores.js';

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const { currentTheme } = useThemeContext();
  const storeData = useStores(currentTheme?.id);

  return (
    <StoreContext.Provider value={storeData}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStoreContext() {
  const context = useContext(StoreContext);
  
  if (!context) {
    throw new Error('useStoreContext must be used within a StoreProvider');
  }
  
  return context;
}

export default StoreContext;
